/* esm.sh - devlop@1.1.0 */
function n(e){return e}function t(){}function o(){}function r(){}export{n as deprecate,t as equal,o as ok,r as unreachable};
//# sourceMappingURL=devlop.mjs.map